import { apiDev, apiProd } from "../lib/axios";
import { BRIDGE_PRODUCTION, BridgeEnv } from "../typings";

const getAPI = (env?: BridgeEnv): any => {
  return env === BRIDGE_PRODUCTION ? apiProd : apiDev;
};

export default getAPI;
